import React from 'react'
import { FreeConsultancyVideoSection } from 'components'

const FreeConsultancyVideoPage = () => {
    document.title = 'Consultoria Gratuita - Liberada'
    return (
        <main className='bg-black'>
            <FreeConsultancyVideoSection />
        </main>
    )
}

export default FreeConsultancyVideoPage;
